import { render, staticRenderFns } from "./OpportunityDetailsModal.vue?vue&type=template&id=3d35cc2b"
import script from "./OpportunityDetailsModal.vue?vue&type=script&lang=js"
export * from "./OpportunityDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./OpportunityDetailsModal.vue?vue&type=style&index=0&id=3d35cc2b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports